import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './auth.guard';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    }, {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './pages/pages.module#PagesModule'
            }
        ]
    }, {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: './components/dashboard/dashboard.module#DashboardModule'
            }, {
                path: '',
                loadChildren: './components/profile/profile.module#ProfileModule'
            }, {
                path: '',
                loadChildren: './components/consular-register/consular-register.module#ConsularRegisterModule'
            }, {
                path: '',
                loadChildren: './components/requests/requests.module#RequestsModule'
            }
        ],
        canActivate: [AuthGuard]
    }, {
        path: '**',
        redirectTo: 'dashboard'
    }
];
